import React, { useState, useCallback } from 'react';
import {
  string, number, oneOfType, bool, func, shape, arrayOf
} from 'prop-types';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Popover,
  Typography
} from '@one-thd/sui-atomic-components';
import { TrashCan, Edit } from '@one-thd/sui-icons';
import { useConfigService } from '@thd-nucleus/experience-context';
import _cloneDeep from 'lodash/cloneDeep';
import { CabinetDrawer } from '../Walls/CabinetDrawer';
import { useCabinetVisualizerStore } from '../../../../store';
import {
  selectDesignById,
  selectProductsModalType,
  selectDesignMatrixSizeWithDefault,
  selectVizImageRoute
} from '../../../../store/cabinetVisualizer/selectors';
import {
  editProduct,
  removeProduct,
  isBoundingBoxEqual,
  isCollidingRange,
  originToBoundingBox
} from '../utils';
import { EMPTY_OBJECT } from '../../../../utils/empty-reference';
import {
  sendRemoveItemFromWallAnalytics,
  sendRemoveAnalytics
} from '../../../../pages/cabinetVisualizer/analytics/analyticsFunctions';
import { SpacerModal } from './SpacerModal';
import { DimensionArrow } from './DimensionArrow';

export const CabinetDimensions = ({
  left, top, width, height, widthDim, heightDim
}) => {

  return (
    <div className="cabinet cabinet-dimensions" style={{ left, top, width, height }}>
      <div className="measurement-width">
        {`${widthDim}" w`}
      </div>
      <DimensionArrow size={1} length={50} type="vertical" label={`${heightDim}" h`} />
    </div>
  );
};

CabinetDimensions.propTypes = {
  left: oneOfType([string, number]),
  top: oneOfType([string, number]),
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  widthDim: number,
  heightDim: number
};

CabinetDimensions.defaultProps = {
  left: 0,
  top: 0,
  width: 0,
  height: 0,
  widthDim: 0,
  heightDim: 0
};
